import { Box, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import clsx from "clsx";
import { useAppSelector } from "../../../app/hooks";
import config from "../../../config/env.config.json";
import { CustomerStatus as CS } from "../../../enums/CustomerStatus";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import { generateImageContainer } from "../../../utils/commonFunctions/generateImageTemplate";
import {
  getResolutionDetails,
  isPromotionalLandingPage,
} from "../../../utils/commonFunctions/ReusableFunctions";
import { ButtonCust } from "../../widgets/Button/ButtonCust";
import { HomeBannerProps } from "./HomeBanner";
import Styles from "./S1_HomeBanner.module.scss";
const HomeBannerT1 = (props: HomeBannerProps) => {
  const {
    heading,
    sub_heading,
    button_text,
    banner_web,
    banner_mobile,
    banner_ipad,
    button_text2,
    list_items,
    heading2,
    res,
    land_web_bnr,
    land_ipad_bnr,
    land_mweb_bnr,
    land_heading,
    land_sub_hdng,
  } = props?.bannerContent || {};
  const { subDomainData } = useAppSelector((state: any) => state.homepage);
  const { largeDesktop, desktop, ipad, mobile } = getResolutionDetails();
  const { pageName, isLandingPage } = props;
  const { content_carousel, ticks_main_div, list_item_txt, button2 } = Styles;
  let customerDetails: any = localStorage?.getItem("customerDetail");
  customerDetails = JSON.parse(customerDetails);
  const { status } = customerDetails || {};

  const data = (localStorage.getItem('landingPageConfigData'));
  const configData = data && JSON.parse(data);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        position: "relative",
        minHeight: { xs: "252px", sm: "300px", md: "300px", lg: "500px" },
      }}
    >
      {banner_web ||
      banner_ipad ||
      banner_mobile ||
      land_web_bnr ||
      land_ipad_bnr ||
      land_mweb_bnr ? (
        <>
          <Paper sx={{ padding: 0 }} elevation={0}>
            {(largeDesktop || desktop) &&
              generateImageContainer({
                altText: banner_web?.data?.attributes?.alternativeText,
                data:
                (isLandingPage && configData && configData?.header && configData?.header?.imageURL)
                ? configData?.header?.imageURL :
                  (subDomainData &&
                  subDomainData?.data?.bannerImageUrl?.replace(/\s+/g, ""))
                    ? subDomainData?.data?.bannerImageUrl?.replace(/\s+/g, "")
                    : isPromotionalLandingPage()
                    ? land_web_bnr
                    : banner_web,
                attrs: {
                  width: "100%",
                  height: "auto",
                },
              })}
            {ipad &&
              generateImageContainer({
                altText: banner_ipad?.data?.attributes?.alternativeText,
                data:
                (isLandingPage && configData && configData?.header && configData?.header?.iPadImageURL)
                ? configData?.header?.iPadImageURL :
                  (subDomainData &&
                  subDomainData?.data?.bannerImageIpadUrl?.replace(/\s+/g, ""))
                    ? subDomainData?.data?.bannerImageIpadUrl?.replace(
                        /\s+/g,
                        ""
                      )
                    : isPromotionalLandingPage()
                    ? land_ipad_bnr
                    : banner_ipad,
                attrs: {
                  width: "100%",
                  height: "auto",
                },
              })}
            {mobile &&
              generateImageContainer({
                altText: banner_mobile?.data?.attributes?.alternativeText,
                data:
                (isLandingPage && configData && configData?.header && configData?.header?.mWebImageURL)
                ? configData?.header?.mWebImageURL :
                  (subDomainData &&
                  subDomainData?.data?.bannerImageMwebUrl?.replace(/\s+/g, ""))
                    ? subDomainData?.data?.bannerImageMwebUrl?.replace(
                        /\s+/g,
                        ""
                      )
                    : isPromotionalLandingPage()
                    ? land_mweb_bnr
                    : banner_mobile,
                attrs: {
                  width: "100%",
                  height: "auto",
                },
              })}
          </Paper>
          <Grid
            sx={{
              position: "absolute",
              textAlign: {
                xs: "var(--main_banner_title_f_align_mobile)",
                sm: "left",
              },
              // paddingTop: {xs: '70px', sm: '0px'}
            }}
            className={content_carousel}
          >
            <Grid item>
              <Box sx={{ textAlign: "center" }}>
                {(heading || land_heading) && (
                  <Typography
                    sx={{
                      width: { xs: "100%", sm: "70%" },
                      fontSize: {
                        xs: "26px !important",
                        sm: "40px !important",

                        lineHeight: " 1.3 !important",
                      },
                      textAlign: {
                        xs: res?.headingAlignment_xs
                          ? res?.headingAlignment_xs
                          : "center",
                        lg: res?.headingAlignment_lg
                          ? res?.headingAlignment_lg
                          : "center",
                      },
                    }}
                    component="h1"
                    variant="h3"
                    gutterBottom
                    className={`main_banner_title ${Styles.heading_color}`}
                    dangerouslySetInnerHTML={{
                      __html: BrandNameUpdate(
                        (isLandingPage && configData?.header && configData?.header?.heading)
                        ? configData?.header?.heading?.replace(/<[^>]*>/g, '') :
                        subDomainData?.data?.brandMainTag
                          ? subDomainData?.data?.brandMainTag
                          : isPromotionalLandingPage()
                          ? land_heading
                          : heading
                      ),
                    }}
                  />
                )}
                {heading2 && (
                  <Typography
                    component="h3"
                    variant="h3"
                    gutterBottom
                    className={`main_banner_title ${Styles.heading_color}`}
                  >
                    {BrandNameUpdate(heading)}
                  </Typography>
                )}
                {(sub_heading || land_sub_hdng) && (
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "16px !important",
                        sm: "20px !important",
                      },
                      fontWeight: "var(--font_weight_1) !important",
                      textAlign: {
                        xs: res?.headingAlignment_xs
                          ? res?.headingAlignment_xs
                          : "center",
                        lg: res?.headingAlignment_lg
                          ? res?.headingAlignment_lg
                          : "center",
                      },
                      color: res?.subHeadingColor ? res?.subHeadingColor : "",
                    }}
                    variant="h4"
                    component="h4"
                    className={clsx(
                      ticks_main_div,
                      "main_banner_sub_title",
                      Styles.heading_color
                    )}
                  >
                    {BrandNameUpdate(
                      (isLandingPage && configData?.header && configData?.header?.subHeading)
                      ? configData?.header?.subHeading?.replace(/<[^>]*>/g, '') :
                      subDomainData?.data?.brandSubTag
                        ? subDomainData?.data?.brandSubTag
                        : isPromotionalLandingPage()
                        ? land_sub_hdng
                        : sub_heading
                    )}
                  </Typography>
                )}
                {list_items?.length > 0 ? (
                  <Box
                    width={"100%"}
                    pb={{
                      xs: "15px",
                      md: "25px",
                    }}
                    sx={{ ml: { xs: "45px", md: "unset" } }}
                  >
                    {list_items.map((item: any, index: any) => {
                      return (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: "10px 0px 0px",
                          }}
                        >
                          {item?.image?.data?.attributes?.url ? (
                            <Box
                              component={"img"}
                              alt={BrandNameUpdate(
                                item?.image?.data?.attributes?.alternativeText
                              )}
                              src={item?.image?.data?.attributes?.url}
                              sx={{ width: "16px" }}
                            />
                          ) : null}
                          <Box className={list_item_txt}>{item?.offer}</Box>
                        </Box>
                      );
                    })}
                  </Box>
                ) : null}
                {button_text && (
                  <ButtonCust
                    variantType={config.PRIMARY_BUTTON_TYPE}
                    onClick={props.onButton1Click}
                    sx={{
                      width: "250px",
                      position: "relative",
                      display: "flex",
                      margin: { xs: "auto", md: "0" },
                    }}
                    disabled={
                      pageName === "PostActivationHome" &&
                      status !== CS.ACTIVE &&
                      status !== CS.SUSPENDED
                        ? true
                        : false
                    }
                  >
                    {button_text}
                  </ButtonCust>
                )}
                {button_text2 && (
                  <Box
                    className={button2}
                    sx={{
                      display: "flex",
                      cursor: "pointer",
                      justifyContent: { xs: "center", sm: "start" },
                      width: { sm: "max-content" },
                      position: { sm: "absolute" },
                      left: { sm: "6%" },
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ fontFamily: "inherit" }}
                      onClick={() => props.onButton2Click()}
                    >
                      {button_text2}
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            minHeight: { xs: "500px", sm: "300px", md: "300px", lg: "500px" },
          }}
        >
          <Stack spacing={1} width="70%">
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
          </Stack>
        </Box>
      )}
    </Container>
  );
};

export default HomeBannerT1;
